import React from "react";
import { ITkTitleProps } from "../../../type/componentsType/TkTitle.d";
import "./_style.scss";

/**
 * TkTitleコンポーネントは、オプションのサイズとカスタムのclassNameを持つタイトルを表示します。
 * 
 * @param {ITkTitleProps} props - コンポーネントのプロパティ
 * @param {React.ReactNode} props.children - タイトルの内容
 * @param {string} props.className - カスタムのclassName
 * @param {string} props.size - タイトルのサイズ
 * @returns {React.ReactNode} タイトルコンポーネント
 */
const TkTitle: React.FC<ITkTitleProps> = (props) => {
  const { children, className, size } = props;

  return (
    <span className={`tkTitle ${className} ${size}`}>
      {children}
    </span>
  );
};

export default TkTitle;
